import cx from 'clsx';
import React from 'react';
import { useController, useWatch } from 'react-hook-form';

import useTranslation from '@hooks/useTranslation';

import { aiTypesList } from '../../constants/aiTypesList';
import { ADD_AI_FIELDS } from '../../constants/schemaAddActionItem';
import AiTypeIcon from '../AiTypeIcon/AiTypeIcon';
import style from './style.module.scss';

const StepAIType = ({ control, filledAiType }) => {
  const { t } = useTranslation();

  const {
    field: { value: typeValue, onChange: setType },
    fieldState: { error },
  } = useController({ control, name: ADD_AI_FIELDS.TYPE });

  const aiOptionValue = useWatch({
    control,
    name: ADD_AI_FIELDS.OPTION,
  });

  return (
    <>
      <div className={style.stepAiType}>
        {aiTypesList.map((type) => (
          <div
            key={type.name}
            className={cx(style.typeItem, {
              [style.typeItemSelected]: type.name === typeValue,
              [style.disabled]: filledAiType && type.name !== filledAiType,
            })}
            onClick={() => setType(type.name)}
          >
            <div className={style.typeItemInfo}>
              <div className={style.typeItemTitle}>{t(type.title)}</div>
              <div className={style.typeItemDescr}>{t(type.description[aiOptionValue])}</div>
            </div>
            <AiTypeIcon iconKey={type?.icon[aiOptionValue]} />
          </div>
        ))}
      </div>
      <div className={style.helperText}>{error && t(error?.message)}</div>
    </>
  );
};

export default StepAIType;
